import { composeClassNames } from "@faedev/editor-utils";
import "animate.css";
import { useRouter } from "next/router";
import { CSSProperties, useState } from "react";
import { Button } from "react-bootstrap";
import Heading from "src/components/Heading";
import Translate from "src/components/Translate";
import { sButton } from "src/styles/sButton.module.scss";
import { sGroupTitle } from "src/styles/sGroupTitle.module.scss";
import { sInstructorStepper } from "src/styles/sInstructorStepper.module.scss";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
};

function InstructorStepper({ style, className }: Props) {
  const { locale: lang, push } = useRouter();
  const [activeStep, setActiveStep] = useState(1);

  return (
    <div
      style={style}
      className={composeClassNames([
        sInstructorStepper,
        className,
        "instructor-stepper-wrapper",
      ])}
    >
      <Heading
        type={`h3`}
        title={<Translate tKey={`Are you a yoga instructor?`} />}
        className={composeClassNames([sGroupTitle, "instructor-stepper-title"])}
      />
      <p className={"instructor-stepper-subtitle"}>
        <Translate
          tKey={`Our community is growing. Just a few steps to be visible and start to sell your content. Don’t miss it!`}
        />
      </p>

      {/* START responsive stepper navigation */}
      <div className={"instructor-stepper-resp"}>
        <div
          className={`instructor-stepper-resp-step ${
            activeStep === 1 && "active"
          }`}
          onClick={() => setActiveStep(1)}
        >
          <div className={"instructor-stepper-resp-step-number"}>1</div>
        </div>
        <div
          className={`instructor-stepper-resp-step ${
            activeStep === 2 && "active"
          }`}
          onClick={() => setActiveStep(2)}
        >
          <div className={"instructor-stepper-resp-step-number"}>2</div>
        </div>
        <div
          className={`instructor-stepper-resp-step ${
            activeStep === 3 && "active"
          }`}
          onClick={() => setActiveStep(3)}
        >
          <div className={"instructor-stepper-resp-step-number"}>3</div>
        </div>
        <div
          className={`instructor-stepper-resp-step ${
            activeStep === 4 && "active"
          }`}
          onClick={() => setActiveStep(4)}
        >
          <div className={"instructor-stepper-resp-step-number"}>4</div>
        </div>
      </div>
      {/* END responsive stepper navigation */}

      <div className={"instructor-stepper"}>
        <div
          className={`instructor-stepper-step ${activeStep === 1 && "active"} `}
          onClick={() => setActiveStep(1)}
        >
          <div className={"instructor-stepper-step-number"}>1</div>
          <div
            className={`instructor-stepper-step-body ${
              activeStep === 1 && "animate__animated animate__pulse"
            }`}
          >
            <div className={"instructor-stepper-step-title"}>
              <Translate tKey={`Create your profile`} />
            </div>
            <div className={"instructor-stepper-step-text"}>
              <Translate
                tKey={`A well-filled profile will allow you to be visible.`}
              />
            </div>
          </div>
        </div>
        <div
          className={`instructor-stepper-step ${activeStep === 2 && "active"}`}
          onClick={() => setActiveStep(2)}
        >
          <div className={"instructor-stepper-step-number"}>2</div>
          <div
            className={`instructor-stepper-step-body ${
              activeStep === 2 && "animate__animated animate__pulse"
            }`}
          >
            <div className={"instructor-stepper-step-title"}>
              <Translate tKey={`Make an offering`} />
            </div>
            <div className={"instructor-stepper-step-text"}>
              <Translate
                tKey={`Do you have your topic? Great, offer it to customers.`}
              />
            </div>
          </div>
        </div>
        <div
          className={`instructor-stepper-step ${activeStep === 3 && "active"}`}
          onClick={() => setActiveStep(3)}
        >
          <div className={"instructor-stepper-step-number"}>3</div>
          <div
            className={`instructor-stepper-step-body ${
              activeStep === 3 && "animate__animated animate__pulse"
            }`}
          >
            <div className={"instructor-stepper-step-title"}>
              <Translate tKey={`Share with community`} />
            </div>
            <div className={"instructor-stepper-step-text"}>
              <Translate
                tKey={`We will help you promote and make the offer visible.`}
              />
            </div>
          </div>
        </div>
        <div
          className={`instructor-stepper-step ${activeStep === 4 && "active"}`}
          onClick={() => setActiveStep(4)}
        >
          <div className={"instructor-stepper-step-number"}>4</div>
          <div
            className={`instructor-stepper-step-body ${
              activeStep === 4 && "animate__animated animate__pulse"
            }`}
          >
            <div className={"instructor-stepper-step-title"}>
              <Translate tKey={`Get paid`} />
            </div>
            <div className={"instructor-stepper-step-text"}>
              <Translate
                tKey={`Payments and billing, everything just works.`}
              />
            </div>
          </div>
        </div>
      </div>

      <div className={"instructor-stepper-resp-buttons"}>
        <Button
          variant={activeStep === 1 ? `outline-primary` : `primary`}
          onClick={() => activeStep !== 1 && setActiveStep(activeStep + -1)}
          className={composeClassNames([sButton])}
        >
          <Translate tKey={`Previous`} />
        </Button>
        <Button
          variant={activeStep === 4 ? `outline-primary` : `primary`}
          onClick={() => activeStep !== 4 && setActiveStep(activeStep + 1)}
          className={composeClassNames([sButton])}
        >
          <Translate tKey={`Next`} />
        </Button>
      </div>
      <div className={"instructor-stepper-join-us"}>
        <Button
          variant={activeStep === 4 ? `primary` : `outline-primary`}
          onClick={() => push("/join-us")}
          className={composeClassNames([sButton])}
        >
          <Translate tKey={`Join Anandita and create profile`} />
        </Button>
      </div>
    </div>
  );
}

export default InstructorStepper;
